import React from 'react'
import PropTypes from 'prop-types'

const Col = ({ children, width, className }) => {
  const htmlClasses = ['col', className]
  width && htmlClasses.push(`col-${width}`)

  return (
    <div className={htmlClasses.join(' ')}>
      {children}
    </div>
  )
}

Col.propTypes = {
  children: PropTypes.node.isRequired,
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  className: PropTypes.string
}

Col.defaultProps = {
  className: '',
  width: null
}

export default Col
